import { useRelativeDate } from './useRelativeDate';

export const RelativeDate = ({
  date: dateString,
  className,
}: {
  date: string;
  className?: string;
}) => {
  const { absolute, showRelative, relative } = useRelativeDate(dateString);
  if (showRelative) {
    return (
      <span className={className} title={absolute}>
        {relative} ago
      </span>
    );
  }
  return (
    <span className={className} title={absolute}>
      {absolute}
    </span>
  );
};
